import { useParams } from 'react-router'
import { Flex, Grid, isLightColor, Text, useMantineTheme } from '@mantine/core'
import React from 'react'
import { useGetLandingPageQuery } from '../redux/query/LandingPagesApi.slice'
import ErrorLoading from '../../../react/core/ErrorLoading'
import Loading from '../../../react/core/Loading'
import Banner from '../components/Banner'
import JobList from './../components/JobList'
import { useMediaQuery } from '@mantine/hooks'

const WIDTH = { base: '90%', md: '80%', lg: '60%' }
const MAX_WIDTH = '1170px'
const JOB_POSTING_COLS = { base: 12, md: 12, lg: 12 }

/**
 * Renders the landing page page.
 * @param {boolean} [embedded] If set to true, the header will be hidden and the job postings will be opened in a
 * new tab.
 * @returns {JSX.Element}
 */
export default function LandingPage ({
  embedded = false
}) {
  const { landing_page_identifier: landingPageIdentifier } = useParams()
  const theme = useMantineTheme()
  const isSmallScreen = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)

  const { data: landingPage, isError, isLoading } = useGetLandingPageQuery(landingPageIdentifier)

  if (isError) {
    return <ErrorLoading />
  }

  if (isLoading) {
    return <Loading />
  }

  document.title = landingPage.company_name && landingPage.company_name.length > 0 ? (landingPage.company_name + ' job listings') : 'Job listings'

  return (
    <Flex
      gap='md'
      justify='center'
      align='center'
      direction='column'
      wrap='wrap'
      h='100%'
      pb='5em'
    >
      {!embedded && <LandingPageBanner landingPage={landingPage} isSmallScreen={isSmallScreen} />}
      <Grid w={WIDTH} maw={MAX_WIDTH} mt={!embedded ? '-9.5vh' : 'sm'}>
        <Grid.Col span={JOB_POSTING_COLS}>
          <JobList landingPage={landingPage} openInNewTab={embedded} />
        </Grid.Col>
      </Grid>
    </Flex>
  )
}

/**
 * Renders the landing page banner.
 * @param {boolean} isSmallScreen
 * @param {object} landingPage The landing page to render the banner for.
 * @returns {JSX.Element}
 */
function LandingPageBanner ({ landingPage, isSmallScreen }) {
  return (
    <Banner
      imageSrc={landingPage.header_image_banner}
      color={landingPage.header_banner_color}
    >
      <Text w={WIDTH} maw={MAX_WIDTH} c={isLightColor(landingPage.header_banner_color) ? 'gray.8' : '#FFF'} size={isSmallScreen ? '24px' : '48px'} aria-label='Landing page title'>
        {landingPage.title}
      </Text>
    </Banner>
  )
}
